<template>
  <div class="grid grid-cols-5 justify-items-stretch items-center gap-1">
    <div
      v-if="!areImagesTaken"
      class="justify-center items-center col-span-5"
      style="
        background-color: rgb(235, 239, 240);
        border-style: solid;
        border-color: rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240)
          rgb(235, 239, 240);
        border-radius: 5px;
      "
    >
      <p class="text-xs text-center">Keine Bilder hinzugefügt</p>
    </div>
    <div
      v-else
      v-for="imgObj in arrayWithFiveElementsAndImages"
      :key="imgObj"
      class="flex item-stretch justify-center items-center"
      style="
        height: 150px;
        max-height: 150px;
        border-radius: 5px;
        border-style: solid;
        border-color: rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240)
          rgb(235, 239, 240);
        background-color: rgb(235, 239, 240);
      "
    >
      <img
        v-if="getPhotoUrl(imgObj)"
        :src="getPhotoUrl(imgObj)"
        data-cy="image"
        style="height: 150px; max-height: 150px"
        class="self-center"
      />
      <div
        v-else
        class="flex item-stretch justify-center items-center"
        style="
          height: 150px;
          max-height: 150px;
          background-color: rgb(235, 239, 240);
          border-radius: 5px;
          border-style: solid;
          border-color: rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240)
            rgb(235, 239, 240);
        "
      >
        <p class="text-xs text-center self-center">Kein Bild hinzugefügt</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import useUser from '@/composables/useUser';
import Bestandsaufnahme from '@/models/ba/Bestandsaufnahme';
import Immobilie from '@/models/immobilie.model';
import { defineComponent, PropType, toRef } from 'vue';
import { useI18n } from 'vue-i18n';
import moment from 'moment';
import { useIdentifierFrageFinder } from '@/composables/Bestandsaufnahme/useIdentifierFinder';
import UniversalPdfImageRow from '../Components/UniversalPdfImageRow.vue';
import { getPhotoUrl } from '@/utilities/get-media-url';
import { Fragenblock } from '@/models/ba/Fragenblock';

export interface ImageObjects {
  image: any;
  title: string;
  width: 'double' | undefined;
}

export default defineComponent({
  name: 'OneToFiveImageDivMehrfach',
  components: { UniversalPdfImageRow },
  props: {
    imageObjects: {
      type: Array,
      required: false,
    },
    fragenblock: {
      type: Object as PropType<Fragenblock>,
      required: true,
    },
    fragesPath: {
      type: String,
      required: true,
      default: '',
    },
    ba: {
      type: Object as PropType<Bestandsaufnahme>,
      required: true,
    },
    immobilie: {
      type: Object as PropType<Immobilie>,
      required: true,
    },
    lang: {
      type: String,
      default: 'de',
    },
  },
  setup(props: any) {
    const { t } = useI18n({ useScope: 'global' });
    const uUser = useUser();
    const arrayWithFiveElementsAndImages: any[] = [[], [], [], [], []];
    let areImagesTaken = false;
    //this is a way

    if (
      props.imageObjects?.value != null ||
      props.imageObjects?.value != undefined
    ) {
      areImagesTaken = true;
      const a = toRef(props, 'imageObjects');
      for (let i = 0; i <= a.value.length; i++) {
        arrayWithFiveElementsAndImages[i] = a.value[i];
      }
    } else if (props.ba != undefined && props.fragesPath != undefined) {
      const images = props.fragenblock.findFrageByRelativePath(props.ba, props.fragesPath)?.[
        'eingabeMedien'
      ];

      if (undefined !== images) {
        if (images?.length >= 1) {
          areImagesTaken = true;
        }
        for (let i = 0; i <= images.length; i++) {
          arrayWithFiveElementsAndImages[i] = images[i];
        }
      }
    }
    return {
      getPhotoUrl,
      user: uUser.user,
      t,
      moment,
      arrayWithFiveElementsAndImages,
      areImagesTaken,
    };
  },
});
</script>
<style scoped>
* {
  color: rgb(23, 68, 81);
  font-family: 'Avenir-Next-LT-Pro-Regular';
}
</style>
